export default {
  NAME: "IM",
  // ENV: "LOCAL",
  ENV: "PRODUCTION",
  // ENV:"STAGING",`

  /* MSG91 OTP Widget — fill from MSG91 panel → OTP → Widget → Client side integration */
  MSG91: {
    WIDGET_ID: "3667416e7466373536393832", // e.g. "356xxxxxxxxxxxxxxx"
    TOKEN_AUTH: "429935TVlU4wrm5b6a676a04P1", // tokenAuth from Select Token dropdown
  },
};
